const $inject = ['$scope', '$routeParams', '$filter', 'countriesService', 'dataService'];

const lbaCountrySelectCtrl = function ($scope, $routeParams, $filter, countriesService, dataService) {
  const vm = this;
  const dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);
  vm.data = _.get(dataService.data.activeItem, dataLookUp);

  vm.selectType = vm.settings.selectType || 'multi';
  vm.refreshCountries = refreshCountries;

  if(vm.selectType === 'multi' && !vm.data) {
    vm.data = [];
  }

  $scope.$watchCollection('vm.data', (newData, oldData) => {
    if (newData !== oldData) {
      _.set(dataService.data.activeItem, dataLookUp, newData)
    }
  });

  function refreshCountries(userSearch) {
    const countries = countriesService.get();
    vm.countries = $filter('filter')(countries, userSearch, false);
  }
};

lbaCountrySelectCtrl.$inject = $inject;

export default lbaCountrySelectCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaCountrySelect/lbaCountrySelectCtrl.js